// Supertype mapping - groups related FI types under a common category
const FISuperTypes = {
    'Deposits': ['DEPOSIT', 'TERM-DEPOSIT', 'TERM_DEPOSIT', 'RECURRING_DEPOSIT', 'RECURRING-DEPOSIT'],
    'Insurance': ['INSURANCE_POLICIES', 'GENERAL_INSURANCE', 'LIFE_INSURANCE'],
    'Mutual Funds': ['MUTUAL_FUNDS', 'SIP'],
    'Equities': ['EQUITIES', 'ETF', 'REIT', 'INVIT', 'IDR'],
    'NPS': ['NPS'],
    'CIS': ['CIS'],
    'AIF': ['AIF'],
    'GST': ['GSTR1_3B'],
};

// Legacy mapping for backward compatibility
const FIGroups = {
    'Deposit': ['DEPOSIT'],
    'Term Deposit': ['TERM-DEPOSIT', 'TERM_DEPOSIT'],
    'Recurring Deposit': ['RECURRING_DEPOSIT', 'RECURRING-DEPOSIT'],
    'Insurance': ['INSURANCE_POLICIES'],
    'General Insurance': ['GENERAL_INSURANCE'],
    'Life Insurance': ['LIFE_INSURANCE'],
    'Mutual Funds': ['MUTUAL_FUNDS'],
    'Equities': ['EQUITIES'],
    'GSTIN': ['GSTR1_3B'],
    'NPS': ['NPS'],
    'ETF': ['ETF'],
    'REIT': ['REIT'],
    'INVIT': ['INVIT'],
    'IDR': ['IDR'],
    'CIS': ['CIS'],
    'AIF': ['AIF'],
    'SIP': ['SIP'],
};

// Create reverse lookup for supertypes (case-insensitive & ignoring _ / -)
const FISuperTypeLookup = Object.entries(FISuperTypes).reduce((acc, [supertype, codes]) => {
    codes.forEach(code => {
        const normalized = code.toLowerCase().replace(/[-_]/g, '');
        acc[normalized] = supertype;
    });
    return acc;
}, {});

// Create reverse lookup (case-insensitive & ignoring _ / -)
const FIGroupLookup = Object.entries(FIGroups).reduce((acc, [group, codes]) => {
    codes.forEach(code => {
        const normalized = code.toLowerCase().replace(/[-_]/g, '');
        acc[normalized] = group;
    });
    return acc;
}, {});

// Get supertype for a given FI type
const getFISuperType = (value) => {
    if (!value) return 'Other';
    const normalized = value.toLowerCase().replace(/[-_]/g, '');
    if (FISuperTypeLookup[normalized]) {
        return FISuperTypeLookup[normalized];
    }
    // Fallback: auto-format unknown codes
    return value
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
};

// Format function for any FI type (for display purposes)
const formatFIType = (value) => {
    if (!value) return '';
    const normalized = value.toLowerCase().replace(/[-_]/g, '');
    if (FIGroupLookup[normalized]) {
        return FIGroupLookup[normalized];
    }
    // Fallback: auto-format unknown codes
    return value
        .replace(/[-_]/g, ' ')       // replace - and _ with spaces
        .replace(/\b\w/g, c => c.toUpperCase()); // capitalize each word
};

export { FIGroups, FIGroupLookup, FISuperTypes, FISuperTypeLookup, getFISuperType, formatFIType };
